const IFRAME_API_SRC = 'https://www.youtube.com/iframe_api';
const DEFAULT_POLL_MS = 5000;

export const PLAYING = 1;

let apiPromise = null;

export function loadYouTubeIframeApi() {
  if (apiPromise) return apiPromise;

  apiPromise = new Promise((resolve, reject) => {
    if (window.YT && window.YT.Player) {
      resolve(window.YT);
      return;
    }

    const existingCallback = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (typeof existingCallback === 'function') existingCallback();
      resolve(window.YT);
    };

    if (document.querySelector(`script[src="${IFRAME_API_SRC}"]`)) return;

    const tag = document.createElement('script');
    tag.src = IFRAME_API_SRC;
    tag.onerror = () => {
      apiPromise = null;
      reject(new Error('The YouTube player could not be loaded.'));
    };
    document.head.appendChild(tag);
  });

  return apiPromise;
}

export async function createYouTubePlayer(element, options = {}) {
  const YT = await loadYouTubeIframeApi();
  return new Promise((resolve) => {
    // eslint-disable-next-line no-new
    new YT.Player(element, {
      ...options,
      events: {
        ...options.events,
        onReady: (event) => resolve(event.target),
      },
    });
  });
}

export function playerDurationSeconds(player) {
  return Math.round(player.getDuration ? player.getDuration() || 0 : 0);
}

export function pollWatchTime(player, onProgress, intervalMs = DEFAULT_POLL_MS) {
  const interval = setInterval(() => {
    if (!player.getPlayerState || player.getPlayerState() !== PLAYING) return;
    const seconds = Math.trunc(player.getCurrentTime ? player.getCurrentTime() || 0 : 0);
    if (seconds > 0) onProgress(seconds);
  }, intervalMs);

  return () => clearInterval(interval);
}
